module.exports = {
  "country": "IS",
  "artist": "Daði og Gagnamagnið",
  "song": "Think about things",
  "year": "2020",
  "place": "CCL",
  "spotify": "77yGu0p7APK39lotu7CLk5"
};